export default {
  canInteract: true,
  pages: [],
  position: {},
  savedPosition: null
};